module.exports = __webpack_public_path__ + "static/media/s2.20582972.jpg";